import { OneSchemaTemplateType } from "./types";

// Templates that require a user confirmation step before the import is committed.
// This is the single source of truth shared by the API and the Oak frontend.
export const GATED_ONESCHEMA_TEMPLATES: ReadonlySet<OneSchemaTemplateType> = new Set([
  OneSchemaTemplateType.Facility,
  OneSchemaTemplateType.Contact, // person importer (FN_MAP key: "contact")
  OneSchemaTemplateType.LEPC,
  OneSchemaTemplateType.FireDepartment,
  OneSchemaTemplateType.Chemical,
  OneSchemaTemplateType.ChemicalComponent,
  OneSchemaTemplateType.StorageLocation,
  OneSchemaTemplateType.ProductChemical,
  OneSchemaTemplateType.FacilityChemicalMeasurement,
  OneSchemaTemplateType.FacilityChemicalStorageLocation,
]);

export function isGatedOneschemaTemplate(t: string): boolean {
  const gatedTemplates: ReadonlySet<string> = GATED_ONESCHEMA_TEMPLATES;
  return gatedTemplates.has(t);
}
